import { SoftphoneStateWorkerInterface } from './worker';

export const SoftphoneStateInterface = SoftphoneStateWorkerInterface;
